<template>
  <div o-Container>
    <div id="div_RegReturnPanel">
      <div class="return" v-if="show">
        <div class="code" id="div_code">[{{status.code}}] {{status.message}}</div>
        <div>Register Module: {{url || "N/A"}}</div>
        <!--        <div>{{source}}</div>-->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound', /* 这个name暂时不知道用啥用，根据官方文档说的是方便排错的 */
    data() {
      return {
        octopus: this.$parent.octopus,
        url: this.$route.query.url,
        show: false,
        status: {
          code: 404,
          message: "Not Found"
        },
      }
    },
    created: function () {
      // this.oData 等价于 this.octopus
      this.oData.tips.debug("RegRouter.vue执行了created事件。");
    },
    mounted: function () {
      this.octopus.tips.debug("RegRouter.vue执行了mounted事件。");
    },
    beforeUpdate: function () {
      this.octopus.tips.debug("RegRouter.vue执行了beforeUpdate事件。");
    },
    updated: function () {
      this.octopus.tips.debug("RegRouter.vue执行了updated事件。");
    },
    activated: function () {
      // 注册路由，如果成功，则跳转，不成功则显示404页面了。
      this.register();
      // 修改token，造成token过期，看系统是否会自动获取token
      // this.octopus.passport.appKey += "a";
      // console.log(this.octopus.passport);
      this.octopus.tips.debug("RegRouter.vue执行了activated事件。");
    },
    deactivated: function () {
      this.octopus.tips.debug("RegRouter.vue执行了deactivated事件。");
    },
    methods: {
      register: function () {
        let o = this;
        // 保存请求地址，路由传参方式
        // this.url = this.$route.params.data;
        // 保存请求地址，url地址传参方式
        // this.url = this.$route.query.url;

        if (!this.octopus.tools.IsNullOrEmpty(this.url)) {
          this.octopus.router.register(this.url, function (data) {
            o.status = data.status;
            if (data.status.code == 200) {
              // o.octopus.tips.debug("RegRouter已经得到对象：" + JSON.stringify(data.content));
              o.octopus.router.jump(o.url);
            }
            // 非正常一律显示
            else {
              // o.octopus.tips.warning("RegRouter未找到对象：" + JSON.stringify(data.status));
              // 如果没找到，则直接跳回登陆页
              // o.octopus.router.jumplogin();
              o.show = true;
            }
          });
        }

        // 异常时，渲染背景。
        $("body").addClass("render");
      },
    },
    props: ["oData", "oDDDDDD"]
  }
</script>




// WEBPACK FOOTER //
// src/components/Engine/Base/RegRouter.vue